import Script from "src/component/script/Script";
import UIManifest from "src/engine/ui/UIManifest";
import { IInfo } from "src/component/props/PropsGGEditor/exec/ExecScript";
import IExecConfig from "src/component/props/PropsGGEditor/exec/IExecConfig";
import PropsUtils from "src/engineEditor/props/utils/PropsUtils";

interface IModuleScript {
    artFlagKey: string;
    toOperateUser?: string;
    propsFromValue?: boolean;
}

/**
 * 模块数据转换
 *
 * @class
 */
@UIManifest.declare("ModuleScript", "ModuleScript脚本", UIManifest.Type.Script)
class ModuleScript extends Script<IModuleScript> {
    handle(value: any, props: any, config: IExecConfig) {
        return value;
    }

    exec(info: IInfo, callback: (info: IInfo) => any) {
        let { value = {} } = info;
        const { propsFromValue } = this.props;
        let { artFlagKey, toOperateUser } = this.props;
        if (propsFromValue) {
            artFlagKey = value.artFlagKey;
            toOperateUser = value.toOperateUser;
            value = value.value;
        }
        const { id, sourceRank, moduleId, operateUser, createTime, offTime, ...mod } = value || {};
        info.value = {};
        info.value.sourceStyle = JSON.stringify(mod);
        if (moduleId) info.value.moduleName = moduleId;
        //将制定key赋值备份到artFlag上，方便搜索
        // PropsUtils.getValue(mod,this.props.artFlagKey);
        if (artFlagKey) {
            const list = artFlagKey.split(",");
            info.value.sourceFlag = list
                .map((item) => {
                    return PropsUtils.getValue(mod, item);
                })
                .join(",");
        }
        if (toOperateUser && value[toOperateUser]) {
            info.value.operateUser = value[toOperateUser];
        }
        if (offTime) info.value.offTime = offTime;
        if (createTime) info.value.createTime = createTime;
        if (sourceRank) info.value.sourceRank = sourceRank;
        if (id) info.value.id = id;
        return true;
    }
}

export default ModuleScript;
